$(document).ready(function () {
  $('.header-top-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: false,
    dots: false,
    infinite: true,
    speed: 1000,
    pauseOnHover: true,
    adaptiveHeight: false
  });
});